import { DatePipe } from '@angular/common';
import { Component, computed } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { Client } from '../../../../api/app-types/client.app';
import { ClientDocumentsResponse } from '../../../../api/app-types/document.app';
import { CUSTOM_DATE_FORMATS } from '../../../../core/adapters/custom-date-format';
import { LvrRedirectNav } from '../../../../core/classes/redirect-nav.class';
import { LvrHeading } from '../../../../core/components/heading/heading';
import { LvrSpacer } from '../../../../core/components/spacer/spacer';
import { LvrPaddingDirective } from '../../../../shared/padding/padding.directive';
import { ClientResolved } from '../../../../shared/routing/resolvers/client.resolver';
import { DocumentsList } from '../documents-list/documents-list';
import { TemplatesList } from '../templates-list/templates-list';

@Component({
	selector: 'lvr-documents-view',
	imports: [DatePipe, LvrHeading, TranslocoPipe, LvrPaddingDirective, TemplatesList, LvrSpacer, DocumentsList],
	templateUrl: './documents-view.html',
})
export class DocumentsView extends LvrRedirectNav {
	private readonly clientResolved = this.resolveDataAsSignal<ClientResolved>('client');
	public readonly client = computed<Client | undefined>(() => {
		const c = this.clientResolved();
		return c?.kind === 'full' ? c.value : undefined;
	});
	public readonly clientId = computed(() => this.clientResolved()?.value?.id);

	public readonly clientDocuments = this.resolveDataAsSignal<ClientDocumentsResponse>('clientDocuments');
	public readonly templates = computed(() => this.clientDocuments()?.commonEntries ?? []);
	public readonly documents = computed(
		() => this.clientDocuments()?.entries ?? { totalEntities: 0, range: 0, offset: 0, entities: [] },
	);

	public readonly dateDisplayFormat: string = CUSTOM_DATE_FORMATS.display.dateInput;
}
